<template lang="pug">
    .search
        .wrapper
            .src_bg
                input(title='Search', ref="search", v-model="txt", placeholder="Eg. Cells or tier: 3" @keyup.enter='enter')
</template>

<script>
    export default {
        name: "search"
        , data() {
            return {txt: '', maps: this.$root.$children[0].maps}
        }
        // , mounted(){
        //     this.maps = ;
        // }
        , computed: {
            src() {
                return this.txt.toLowerCase();
            }
            , src_w() {
                return this.txt.toLowerCase().replace(new RegExp(/\s/g), "");
            }
        }
        , watch: {
            txt: function () {
                for (let map of Object.values(this.maps)) {
                    let name_match = this.src_w.length > 0 && map.name.replace(new RegExp(/\s/g), '').toLowerCase().indexOf(this.src_w) >= 0;
                    let tier_match = this.src_w === ("tier:" + map.tier);
                    map.highlighted = name_match || tier_match;
                }
            },
        }
        , methods: {
            enter() {
                let complete_r = /^complete:([0-9]{1,2})$/;
                let uncomplete_r = /^incomplete:([0-9]{1,2})$/;
                if (complete_r.test(this.src_w)) {
                    let tier = parseInt(this.src_w.match(complete_r)[1]);
                    for (let map of Object.values(this.maps)) {
                        if (map.tier === tier)
                            map.complete = true;
                    }
                } else if (uncomplete_r.test(this.src_w)) {
                    let tier = parseInt(this.src_w.match(uncomplete_r)[1]);
                    for (let map of Object.values(this.maps)) {
                        if (map.tier === tier)
                            map.complete = false;
                    }
                }else{
                    let match='01234567890123456789';
                    for (let map of Object.values(this.maps)) {
                        let name_match = this.src_w.length > 0 && map.name.replace(new RegExp(/\s/g), '').toLowerCase().indexOf(this.src_w) >= 0;
                        if(name_match && match.length > map.id.length){
                            match = map.id;
                        }
                    }
                    if (match.length < 20) {
                        this.$root.$children[0].zoom_to_map(match);
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .search {
        position: absolute;
        top: 0;
        left: 50%;
        width: 505px;
        margin-left: -132px;
        .src_bg {
            padding: 5px 27px 35px 40px;
            background: url('img/search_bg.png') no-repeat;
            float: left;
            width: 215px;
            input {
                &:focus {
                    outline: none;
                }
                background: none;
                width: 100%;
                border: none;
                height: 20px;
            }
        }
        /*.help {*/
        /*margin: 4px 0;*/
        /*!*background-image: url('img/help.png');*!*/
        /*background: rgba(0, 255, 0, 1);*/
        /*border: 1px solid rgba(255, 255, 0, 1);*/
        /*border-radius:1em;*/
        /*width: 35px;*/
        /*height: 29px;*/
        /*display: inline-block;*/
        /*}*/
    }
</style>


// WEBPACK FOOTER //
// src/components/Search.vue